import React from "react";
import styled from "styled-components";
import Tooltip from "@mui/material/Tooltip";
import CenterFocusWeakSharpIcon from "@mui/icons-material/CenterFocusWeakSharp";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { centerGraph } from "../../utils/DiagramUtils";

const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 30px;
  left: 30px;
  cursor: pointer;
  z-index: 1000;
  background: transparent;
  color: #ffa59c;

  display: flex;
  align-items: center;
  justify-content: center;

  /* Default state */
  .centerIcon {
    font-size: 50px;
    transition: font-size 0.2s ease;
  }

  /* Hover state, increase size of icon */
  &:hover .centerIcon {
    font-size: 60px;
  }
`;

const CenterGraphButton: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleCenterGraph = async () => {
    try {
      await centerGraph();
    } catch (error) {
      console.error("Error centering graph:", error);
      enqueueSnackbar("Failed to center graph", { variant: "error" });
    }
  };

  return (
    <Tooltip
      title={
        <Typography variant="body2" style={{ fontSize: "13px" }}>
          Centers the diagram view. If a cell is selected, centers on that cell.
          Otherwise, shows all cells.
        </Typography>
      }
      arrow
    >
      <ButtonWrapper
        onClick={handleCenterGraph}
        data-testid="centerGraphButton"
      >
        <CenterFocusWeakSharpIcon className="centerIcon" />
      </ButtonWrapper>
    </Tooltip>
  );
};

export default CenterGraphButton;
